import NumberUtils from '../primitives/NumberUtils';
Number.prototype.toBoolean = function () {
    return NumberUtils.toBoolean(this);
};
Number.compare = NumberUtils.compare;
Number.ensureValid = NumberUtils.ensureValid;
Number.isNumber = NumberUtils.isNumber;
Number.parse = NumberUtils.parse;
Number.tryParse = NumberUtils.tryParse;
//# sourceMappingURL=NumberExtensions.js.map